import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import i18next from 'i18next';
import Social from './Social';
import { Pages } from '../../constants';
import { Link } from 'react-router-dom';

// استيراد الأيقونات الخاصة بمعلومات الاتصال
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

// استيراد الصورة التراثية الخاصة بالخلفية
import footerBg from '../../assets/footer/footer.png';

const Footer = ({ data }) => {
    let lng = i18next.language;
    // const lng === 'ar' = lng === 'ar';

    const general = data?.general || {};
    const social = data?.social || {};
    const logoUrl = general?.image;

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            {/* الشريط الذهبي العلوي الممتد */}
            <Box sx={{ width: '100%', height: '4px', bgcolor: '#C59850' }} />

            <Box
                sx={{
                    bgcolor: '#F5F1E9',
                    color: '#29241F',
                    pt: 6,
                    pb: { xs: 6, md: 12 }, // تقليل البادينغ السفلي على الهواتف لشكل أرشق
                    position: 'relative',
                    overflow: 'hidden',
                    backgroundImage: `url(${footerBg})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 500px',
                }}>
                <Container maxWidth={'xl'} sx={{ px: { xs: 3, md: 4 }, position: 'relative', zIndex: 2 }}>

                    <Grid container spacing={{ xs: 1, md: 3 }}>

                        {/* العمود الأول: اللوجو، الوصف، وأزرار السوشيال ميديا */}
                        <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' },
                                textAlign: { xs: 'center', md: lng === 'ar' ? 'right' : 'left' }
                            }}
                        >
                            {logoUrl ? (
                                <Box component="img" src={logoUrl} alt="logo" sx={{ height: 125, mb: 2, objectFit: 'contain' }} />
                            ) : (
                                <Typography variant="h5" sx={{ color: '#C59850', fontWeight: 700, mb: 2 }}>
                                    {general?.site_name || 'ZAHER AL HOMSI'}
                                </Typography>
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' },
                                textAlign: { xs: 'center', md: lng === 'ar' ? 'right' : 'left' }
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#55524E',
                                    lineHeight: 1.8,
                                    mb: 3,
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    maxWidth: '340px'
                                }}
                            >
                                {lng === 'ar'
                                    ? 'نقدم حلولاً تجارية متكاملة تجمع بين الجودة والموثوقية والكفاءة، مع التزامنا ببناء شراكات طويلة الأمد وتقديم أفضل المنتجات والخدمات لعملائنا.'
                                    : 'We offer integrated commercial solutions combining quality and reliability...'}
                            </Typography>
                            <Social data={social} color="#C59850" />
                        </Grid>

                        {/* العمود الثاني: روابط سريعة */}
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: 'center' },
                                textAlign: 'center'
                            }}
                        >
                            <Box sx={{ width: 'fit-content', display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: lng === 'ar' ? 'flex-end' : 'flex-start' } }}>
                                <Typography variant="h6" sx={{ color: '#C59850', fontWeight: 700, mb: 3, fontSize: '18px' }}>
                                    {lng === 'ar' ? 'روابط سريعة' : 'Quick Links'}
                                </Typography>

                                {/* تحويل الحاوية إلى Grid باستخدام الـ sx للمرونة التامة */}
                                <Box
                                    sx={{
                                        display: 'grid',
                                        // الشاشات الصغيرة: عمودين متساويين، الشاشات الكبيرة (md فما فوق): عمود واحد
                                        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: '1fr' },
                                        gap: 2.5,
                                        width: '100%'
                                    }}
                                >
                                    {Pages?.map((page, i) => (
                                        <Box
                                            key={i}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                // المحاذاة تعتمد على اتجاه اللغة في الشاشات الكبيرة لتظهر النقاط بشكل صحيح
                                                justifyContent: { xs: lng === 'en' ? 'flex-end' : 'flex-start', md: lng === 'en' ? 'flex-end' : 'flex-start' },
                                                // إذا كنت تفضل أن يكون النص والنقطة دائمًا من اليمين لليسار في العربي على الموبايل أيضًا:
                                                flexDirection: lng === 'en' ? 'row-reverse' : 'row',
                                                gap: 1.5
                                            }}
                                        >
                                            {/* نقطة القائمة الدائرية */}
                                            <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: '#C59850', flexShrink: 0 }} />

                                            <Link
                                                to={page.path}
                                                onClick={scrollToTop}
                                                style={{ color: '#29241F', textDecoration: 'none', fontSize: 15, fontWeight: 600 }}
                                            >
                                                {lng === 'ar' ? page.name : page.name_en}
                                            </Link>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>

                        {/* العمود الثالث: معلومات الاتصال */}
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: { xs: 'center', md: lng === 'ar' ? 'flex-end' : 'flex-start' }
                            }}
                        >
                            <Box sx={{ width: 'fit-content', display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' } }}>
                                <Typography variant="h6" sx={{ color: '#C59850', fontWeight: 700, mb: 3, fontSize: '18px' }}>
                                    {lng === 'ar' ? 'معلومات التواصل' : 'Contact Info'}
                                </Typography>

                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
                                    {/* حقل العنوان */}
                                    {general?.address && (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: { xs: 'row', md: lng === 'ar' ? 'row' : 'row' },
                                            justifyContent: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' },
                                            gap: 2
                                        }}>
                                            <LocationOnIcon sx={{ fontSize: 20, color: '#C59850', flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '14px', color: '#29241F', fontWeight: 600, textAlign: { xs: 'center', md: lng === 'ar' ? 'right' : 'left' } }}>
                                                {general.address}
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* حقل الهاتف */}
                                    {general?.phone && (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: { xs: 'row', md: lng === 'ar' ? 'row' : 'row' },
                                            justifyContent: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' },
                                            gap: 2
                                        }}>
                                            <PhoneIcon sx={{ fontSize: 20, color: '#C59850', flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '14px', color: '#29241F', fontWeight: 600, textAlign: { xs: 'center', md: lng === 'ar' ? 'right' : 'left' }, direction: 'ltr' }}>
                                                {general.phone}
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* حقل البريد الإلكتروني */}
                                    {general?.site_email && (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: { xs: 'row', md: lng === 'ar' ? 'row' : 'row' },
                                            justifyContent: { xs: 'center', md: lng === 'ar' ? 'flex-start' : 'flex-start' },
                                            gap: 2
                                        }}>
                                            <EmailIcon sx={{ fontSize: 20, color: '#C59850', flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '14px', color: '#29241F', fontWeight: 600, textAlign: { xs: 'center', md: lng === 'ar' ? 'right' : 'left' } }}>
                                                {general.site_email}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;